import { render, staticRenderFns } from "./SubEmpresaGestaoElegibilidadeAR.vue?vue&type=template&id=0fae374e&lang=pug"
import script from "./SubEmpresaGestaoElegibilidadeAR.vue?vue&type=script&lang=js"
export * from "./SubEmpresaGestaoElegibilidadeAR.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaGestaoElegibilidadeAR.vue?vue&type=style&index=0&id=0fae374e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports